export default "__VITE_ASSET__C70rB7oj__"